<form class="card mt-2">
  <div class="card-body">
    <div class="float-right">
      <i *ngIf="uploadingFile" class="material-icons rotate text-muted">loop</i>
      <button class="btn btn-warning btn-lo" (click)="uploadFile()" [disabled]="uploadingFile" *ngIf="carrier">Upload now</button>


      <i *ngIf="exportingExcel" class="material-icons rotate text-muted">loop</i>
      <button class="btn btn-secondary ml-2 " (click)="exportToExcel()" [disabled]="exportingExcel">Export</button>

      <a class="btn btn-secondary ml-2 " [routerLink]="'/benefitPlanEDI/tramissions'">Back</a>

    </div>
    <h2 class="mb-3"> {{ carrier || 'Benefit Plan Transmission' }} Members Report</h2>
    <div class="row mb-3" *ngIf="list?.additionalProperties?.hasChanges">
      <div class="col-12">
        <h5 class="text-warning">There changes pending transmission</h5>
      </div>
    </div>
    <div class="row mb-3" *ngIf="list?.additionalProperties?.dateSent">
      <div class="col-3 col-xl-1">
        <h5>Carrier:</h5>
      </div>
      <div class="col-3 col-xl-2  ">
        <h5>{{list?.additionalProperties?.carrier}}</h5>
      </div>

      <div class="col-3 col-xl-2">
        <h5>Date Sent:</h5>
      </div>
      <div class="col-3 col-xl-2">
        <h5>
          {{
list?.additionalProperties?.dateSent | date: 'MM/dd/yyyy'
          }}
        </h5>
      </div>

      <div class="col-3 col-xl-2">
        <h5>File Name:</h5>
      </div>
      <div class="col-9 col-xl-3  ">
        <h5>{{list?.additionalProperties?.fileName}}</h5>
      </div>

    </div>
    <div class="row mb-3" *ngIf="!list?.additionalProperties?.dateSent">
      
      <div class="col-6">
        <div class="row">
          <div class="col-4 d-flex align-items-center">
            <h5>Subscriber Plan:</h5>
          </div>
          <div class="col-8">
            <select [(ngModel)]="filterType" (ngModelChange)="filterTypeChanged()" [ngModelOptions]="{standalone: true}" class="form-control ml-2 w-100 mb-2">
              <option value="Current">Active</option>
              <option value="Removed">Expired</option>
              <option value="OpenEnrolment">Planned</option>
              <option value="All">All</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <i [hidden]="!loadingList" class="material-icons rotate text-muted">loop</i>
    <p-table #myTable [value]="filteredList" [responsive]="true" [paginator]="true" [rows]="1000"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadList($event)"
             [tableStyle]="{ 'min-width': '60rem' }" >
      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'Name'">Name <p-sortIcon [field]="'Name'"></p-sortIcon></th>
          <th [pSortableColumn]="'SSN'">SSN <p-sortIcon [field]="'SSN'"></p-sortIcon></th>
          <th [pSortableColumn]="'BirthDate'">Birth Date / Gender <p-sortIcon [field]="'BirthDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'EmploymentEndDate'">Employment / Relationship<p-sortIcon [field]="'EmploymentEndDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'BenefitBeginDate'"  style="width:130px">Begin Date <p-sortIcon [field]="'BenefitBeginDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'BenefitEndDate'"   style="width: 130px">End Date <p-sortIcon [field]="'BenefitEndDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'PlanCoverage'">Plan Coverage<p-sortIcon [field]="'PlanCoverage'"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-list>
        <tr>
          <td>
            <span class="ui-column-title">Name</span>
            {{list.name}}
          </td>
          <td>
            <span class="ui-column-title">SSN</span>
            {{this.formatSSN(list.ssn)}}
          </td>
          <td>
            <span class="ui-column-title">Birth Date / Gender</span>
            {{list.birthDate  | date: 'MM/dd/yyyy'}} {{list.gender}}
          </td>
          <td>
            <span class="ui-column-title">Employment / Relationship</span>
            <span>
              {{list.employmentBeginDate | date: 'MM/dd/yyyy'}}
            </span>
            <span class=" text-danger" *ngIf="list.employmentEndDate">
              - {{list.employmentEndDate | date: 'MM/dd/yyyy'}}
            </span>
            {{list.employmentStatusCode}}
          </td>
          <td>
            <span class="ui-column-title">BenefitBeginDate</span>
            {{list.benefitBeginDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">BenefitEndDate</span>
            {{list.benefitEndDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">Plan Coverage</span>
            <div *ngFor="let health of getHealthCoverageInfo(list)">
              {{health}}
            </div>
          </td>
        </tr>
        <tr *ngFor="let dependent of filteredDependents(list)" class="font-italic text-secondary">
          <td>
            <span class="ml-2 ">
              {{dependent.name}}
            </span>
          </td>
          <td>
            {{this.formatSSN(dependent.ssn)}}
          </td>
          <td>
            {{dependent.birthDate  | date: 'MM/dd/yyyy'}} {{dependent.gender}}
          </td>
          <td>
            {{dependent.relationship}}
          </td>
          <td>
            <span class="ui-column-title">BenefitBeginDate</span>
            {{dependent.benefitBeginDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">BenefitEndDate</span>
            {{dependent.benefitEndDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">Plan</span>
            <div *ngFor="let health of getHealthCoverageInfo(dependent)">
              {{health}}
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          {{list?.additionalProperties?.description}} <br/>
          {{list?.additionalProperties?.notes}}
        </div>
      </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>
    </p-table>
  </div>
</form>
